<template>
    <canvas ref="chartRef"></canvas>
</template>
  
<script>
  import { defineComponent, onMounted, ref, watch } from 'vue';
  import { Chart, registerables } from 'chart.js';
  
  Chart.register(...registerables);
  
  export default defineComponent({
    name: 'GraphComponent',
    props: {
      type: {
        type: String,
        required: true,
        default: 'bar',
      },
      data: {
        type: Object,
        required: true,
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },
    setup(props) {
      const chartRef = ref(null);
      let chartInstance = null;
  
      const renderChart = () => {
        if (chartInstance) {
          chartInstance.destroy(); // Destroy existing chart before re-rendering
        }
        if (chartRef.value) {
          chartInstance = new Chart(chartRef.value, {
            type: props.type,
            data: props.data,
            options: props.options,
          });
        }
      };
  
      onMounted(renderChart);
      watch(() => [props.data, props.type, props.options], renderChart, { deep: true });
  
      return { chartRef };
    },
  });
  </script>
  